<template>
  <div class="main_content admin">
    <div class="filter_block" style="justify-content: space-between;">
      <div>
        <span>用户名：</span>
        <span style="display: inline-block;">
          <b-form-input v-model="param.username"></b-form-input>
        </span>
        <span>
          <button class="primary_btn" @click="getData(param)">查询</button>
        </span>
      </div>
      <div>
        <button style="margin-right: 15px;" class="secondary_btn" @click="batchDelete">批量删除</button>
        <button class="primary_btn" @click="newLine()">新建</button>
      </div>

    </div>

    <table class="table table-striped table-responsive-sm table-hover green_table">
      <thead>
      <tr>
        <th>
          <b-link href="#" style="font-size: 12px; padding-right: 10px;" @click="selectAll()">全选</b-link>
          <b-link href="#" style="font-size: 12px;" @click="shift()">反选</b-link>
        </th>
        <th scope="col">id</th>
        <th scope="col">用户</th>
        <th scope="col">片区</th>
        <th scope="col">操作</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in data">
        <tr>
          <td>
            <b-form-checkbox style="display: flex;"
                             @click.native.stop="item.selected = !item.selected"
                             v-model="item.selected">
            </b-form-checkbox>
          </td>
          <td>{{ item.id }}</td>
          <td>
            <b-form-select v-model="item.uid" :options="userData"></b-form-select>
          </td>
          <td>
            <b-form-select v-model="item.town" :options="townData"></b-form-select>
          </td>
          <td>
            <b-link @click.stop="save(item)" style="padding-right: 15px;">保存</b-link>
            <b-link @click.stop="delOne(item, index)" style="padding-right: 15px;">删除</b-link>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import UserTownApi from '../../api/userTown'
import Tool from '../../util/tool'
export default {
  data () {
    return {
      param: {
        username: ''
      },
      data: [],
      userData: [],
      townData: []
    }
  },
  components: {
  },
  computed: {

  },
  mounted () {
    Promise.all([
      UserTownApi.getUserList(),
      UserTownApi.getTownList()
    ]).then(values => {
      this.userData = values[0].map(x => {
        return {
          value: x.id,
          text: x.username
        }
      })
      this.townData = values[1].map(x => {
        return {
          value: x.town_code,
          text: x.town_name
        }
      })
      this.getData(this.param)
    }).catch(error => {
      this.$toasted.global.pop_error('加载失败: ' + error)
    })
  },
  methods: {
    selectAll () {
      this.data.forEach(item => {
        item.selected = true
      })
    },
    shift () {
      this.data.forEach(item => {
        item.selected = !item.selected
      })
    },
    getData (params) {
      UserTownApi.queryPage(params).then(resp => {
        this.data = resp.records
        this.data.forEach(item => {
          item.selected = false
        })
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('获取数据失败')
      })
    },
    save (item) {
      UserTownApi.save({
        id: item.id,
        uid: item.uid,
        town: item.town
      }).then(resp => {
        if (Tool.returnSuccess(resp)) {
          this.$toasted.global.pop_success('保存成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('修改失败\n' + error)
      })
    },
    batchDelete () {
      let ids = this.data.filter(x => x.selected).map(x => x.id)
      this.del(ids)
    },
    newLine () {
      this.data.unshift({
        id: undefined,
        uid: '',
        town: ''
      })
    },
    delOne (item, index) {
      if (item.id) {
        this.del([item.id])
      } else {
        this.data.slice(index, 1)
      }
    },
    del (ids) {
      ids = ids.filter(id => id)
      if (ids.length === 0) {
        return
      }
      UserTownApi.del(ids).then(resp => {
        if (Tool.returnSuccess(resp)) {
          this.$toasted.global.pop_success('删除成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error(resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('操作失败: ' + error)
      })
    }
  },
  watch: {}

}
</script>
<style lang="scss" scoped>

</style>
